// extracted by mini-css-extract-plugin
export default {"fullWidth":"Ap-z","image":"Bp-z","lazyLoadPicture":"Cp-z","lazyLoadSpinner":"Dp-z","lazyLoadSpin":"Ep-z","lazyLoadImage":"Fp-z","hasStyledAspectRatio":"Gp-z"};